(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["softboard-finder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.softboard-finder').forEach((finder) => {
    const choices = finder.querySelectorAll('[data-finder-choice]');
    const cards = finder.querySelectorAll('[data-finder-card]');

    const activateChoice = (choice) => {
      choices.forEach((item) => {
        const active = item === choice;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.setAttribute('tabindex', active ? '0' : '-1');
      });
      cards.forEach((card) => {
        card.hidden = card.dataset.finderCard !== choice.dataset.finderChoice;
      });
    };

    choices.forEach((choice) => {
      choice.addEventListener('click', () => {
        activateChoice(choice);
      });

      choice.addEventListener('keydown', (event) => {
        const choiceList = [...choices];
        const currentIndex = choiceList.indexOf(choice);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % choiceList.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + choiceList.length) % choiceList.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = choiceList.length - 1;

        if (nextIndex !== currentIndex) {
          event.preventDefault();
          choiceList[nextIndex].focus();
          choiceList[nextIndex].click();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
